import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

import TitledListItem from '../TitledListItem'
import SectionLoader from '../SectionLoader'

import greenKeyLogo from 'assets/images/green-key-international-logo-vector-svg.webp';

import styles from './SustainableDevelopmentSection.module.scss'

const cx = classnames.bind(styles);

const SustainableDevelopmentSection = function ({
  isLoading,
  info,
  className,
}) {
  const listItems = useMemo(function () {
    return info?.list?.length
      ? info.list.sort((a, b) => a.order > b.order ? 1 : -1)
      : null
  }, [info])
  return (
    <div className={cx('root', className)}>
      {isLoading && (<SectionLoader />)}
      {!isLoading && (
        <>
          {info?.description && (<p className={cx('description')}>{info.description}</p>)}
          {listItems && (
            <ul>
              {listItems.map((el, i) => (
                <TitledListItem title={el.title} key={i}>
                  <div dangerouslySetInnerHTML={{__html: el.text}} />
                  {el.eco && (
                    <img
                      src={greenKeyLogo}
                      alt="Green Key"
                      width={90}
                      height={114}
                      loading="lazy"
                    />
                  )}
                </TitledListItem>
              ))}
            </ul>
          )}
        </>
      )}
    </div>
  )
}

SustainableDevelopmentSection.propTypes = {
  data: PropTypes.any
}

export default SustainableDevelopmentSection;
